<template>

  <div class="wrong-questions-container">

    <div class="page-header">

      <div class="page-title-area">

        <div class="page-title">我的错题本</div>

        <div class="page-subtitle">

          {{ todayOnly ? '今日错题复盘' : '按知识点和时间维度，系统化订正历史错题' }}

        </div>

      </div>

      <div class="page-actions">

        <el-button type="text" @click="goBackToAMCCenter" class="back-btn">

          <i class="el-icon-arrow-left"></i>

          <span>返回备考中心</span>

        </el-button>

      </div>

    </div>



    <div class="summary-bar" v-if="rows && rows.length">

      <div class="summary-item">

        <div class="summary-label">累计错题</div>

        <div class="summary-value">{{ rows.length }}</div>

      </div>

      <div class="summary-item">

        <div class="summary-label">未订正</div>

        <div class="summary-value pending">{{ rows.filter(r => r.status === 'pending').length }}</div>

      </div>

      <div class="summary-item">

        <div class="summary-label">已订正</div>

        <div class="summary-value reviewed">{{ rows.filter(r => r.status === 'reviewed').length }}</div>

      </div>

      <div class="summary-tip" v-if="todayOnly">

        专注于今天做错的题目，快速查漏补缺。

      </div>

    </div>



    <div class="content-card">

      <!-- 顶部工具栏 -->

      <div class="toolbar">

        <div class="toolbar-left">

          <div class="filter-item">

            <span class="filter-label">按订正状态</span>

            <el-tooltip content="按是否订正状态筛选" placement="bottom">

              <el-select v-model="statusFilter" placeholder="状态" clearable class="filter-select" @change="applyFilters">

                <el-option label="全部" :value="''" />

                <el-option label="未订正" value="pending" />

                <el-option label="已订正" value="reviewed" />

              </el-select>

            </el-tooltip>

          </div>

          <div class="filter-item">

            <span class="filter-label">按知识点</span>

            <el-tooltip content="按父级知识点筛选" placement="bottom">

              <el-select v-model="knowledgeFilter" placeholder="知识点" clearable class="filter-select" filterable @change="applyFilters">

                <el-option label="全部" :value="''" />

                <el-option v-for="(k, idx) in knowledgeOptions" :key="`${k}-${idx}`" :label="k" :value="k" />

              </el-select>

            </el-tooltip>

          </div>

          <div class="filter-item">

            <span class="filter-label">错误次数</span>

            <el-tooltip content="按做错次数筛选" placement="bottom">

              <el-select v-model="wrongCountFilter" placeholder="次数" clearable class="filter-select" @change="applyFilters">

                <el-option label="全部" :value="''" />

                <el-option label="1次" :value="1" />

                <el-option label="2次" :value="2" />

                <el-option label="3次" :value="3" />

                <el-option label="4次及以上" value="4+" />

              </el-select>

            </el-tooltip>

          </div>

        </div>

        <div class="toolbar-right">

          <el-date-picker

            v-model="dateRange"

            type="daterange"

            range-separator="至"

            start-placeholder="开始日期"

            end-placeholder="结束日期"

            unlink-panels

            :clearable="true"

            @change="applyFilters"

          />

        </div>

      </div>



      <!-- 上方错题表格 -->

      <el-table

        :data="pagedRows"

        border

        :height="tableHeight"

        highlight-current-row

        :row-class-name="tableRowClassName"

        @row-click="onRowClick"

        @row-dblclick="onRowDblClick"

      >

        <el-table-column label="错题记录" min-width="960">

          <template slot-scope="scope">

            <div class="record-rich-card">

              <div class="record-rich-badges">

                <span class="record-rich-badge is-warn">{{ scope.row.wrongCount > 1 ? `错${scope.row.wrongCount}次` : '答错' }}</span>

                <span class="record-rich-badge is-pending" v-if="scope.row.status === 'pending'">未订正</span>

                <span class="record-rich-badge is-success" v-else>已订正</span>

              </div>

              <div class="record-rich-title" v-mathjax v-html="renderText(scope.row.quesContent || '')"></div>

              <div class="record-rich-meta">

                <span class="record-rich-meta-item is-primary">{{ getRowSourceLabel(scope.row) }}</span>

                <span class="record-rich-meta-item">{{ resolveKnowledgeName(scope.row.knowledge) }}</span>

                <span class="record-rich-meta-item is-danger" v-if="scope.row.userAnswer">我的作答 {{ scope.row.userAnswer }}</span>

                <span class="record-rich-meta-item is-warn" v-if="scope.row.reason">{{ scope.row.reason }}</span>

                <span class="record-rich-meta-item">{{ formatRowTime(scope.row.time) }}</span>

              </div>

            </div>

          </template>

        </el-table-column>

      </el-table>

    </div>



    <!-- 分页 -->

    <div class="pagination">

      <el-pagination

        background

        layout="prev, pager, next"

        :page-size="pageSize"

        :total="filteredRows.length"

        :current-page.sync="currentPage"

      />

    </div>



    <!-- 二级弹窗：题目详情 -->

    <el-dialog

      title="错题详情"

      :visible.sync="showDetailDialog"

      width="80%"

      custom-class="detail-dialog"

      :before-close="() => { showDetailDialog = false }"

    >

      <div class="detail-panel" v-if="current">

        <div class="detail-left">

          <div class="question-block">

            <div class="question-preview-card">

              <div class="question-preview-badges">

                <span class="preview-badge preview-badge-danger"><i class="el-icon-close"></i> 错题</span>

                <span class="preview-badge preview-badge-warn"><i class="el-icon-warning-outline"></i> 错 {{ (current && current.wrongCount) || 1 }} 次</span>

                <span class="status-pill status-pill-pending" v-if="current && current.status === 'pending'"><i class="el-icon-time"></i> 未订正</span>

                <span class="status-pill status-pill-success" v-else-if="current && current.status === 'reviewed'"><i class="el-icon-circle-check"></i> 已订正</span>

              </div>

              <div class="question-preview-title" v-mathjax v-html="renderText((currentQuestion && currentQuestion.content) || '')"></div>

              <div class="question-preview-meta-wrap" v-if="currentQuestion || current">

                <div class="question-preview-meta-title">题目信息</div>

                <div class="question-preview-meta">

                  <span class="question-preview-course" v-if="getQuestionYear(currentQuestion)">{{ getQuestionYear(currentQuestion) }} {{ currentQuestion && currentQuestion.source ? currentQuestion.source : '' }}</span>

                  <span class="question-preview-meta-item" v-if="currentQuestion && currentQuestion.difficulty">

                    难度 {{ formatDifficulty(currentQuestion.difficulty) }}

                  </span>

                  <span class="question-preview-meta-item" v-if="current && current.knowledge">

                    {{ resolveKnowledgeName(current.knowledge) }}

                  </span>

                  <span class="question-preview-meta-item is-wrong" v-if="current && current.reason">{{ current.reason }}</span>

                  <span class="question-preview-meta-item is-danger" v-if="current && current.userAnswer">我的作答 {{ current.userAnswer }}</span>

                </div>

              </div>

            </div>

            <div class="question-image" v-if="getQuestionImages(currentQuestion).length > 0" style="margin:8px 0;">

              <img

                v-for="(imgUrl, imgIdx) in getQuestionImages(currentQuestion)"

                :key="imgIdx"

                :src="resolveImageUrl(imgUrl)"

                alt="题目图片"

                style="max-width:100%; border:1px solid #eee; border-radius:4px; margin-bottom:8px;"

              />

            </div>

          </div>



          <div class="question-block" v-if="currentQuestion && hasQuestionOptions(currentQuestion)">

            <div class="block-title">选项</div>

            <div class="options-list">

              <div v-for="(opt, idx) in parseDetailOptions(currentQuestion)" :key="idx" class="option-item">

                <span class="option-label">{{ getOptionKey(opt, idx) }}.</span>

                <div class="option-content-wrap">

                  <span v-if="getOptionText(opt)" class="option-text" v-mathjax v-html="renderText(getOptionText(opt))"></span>

                  <img

                    v-if="getOptionImage(opt)"

                    class="option-image"

                    :src="resolveImageUrl(getOptionImage(opt))"

                    alt="选项图片"

                    style="display:block; max-width:100%; border:1px solid #eee; border-radius:4px; margin-top:8px;"

                  />

                </div>

              </div>

            </div>

          </div>



          <div class="question-block" v-if="getQuestionAnswer(currentQuestion)">

            <div class="block-title">正确答案</div>

            <div class="analysis-content" v-mathjax v-html="renderText(getQuestionAnswer(currentQuestion))"></div>

          </div>



          <div class="question-block" v-if="getQuestionAnalysis(currentQuestion)">

            <div class="block-title">解析</div>

            <div class="analysis-content" v-mathjax v-html="formatContent(getQuestionAnalysis(currentQuestion))"></div>

          </div>



          <div class="question-block">

            <div class="block-title">我的笔记</div>

            <el-input

              v-model="editNote"

              type="textarea"

              :rows="3"

              placeholder="在此添加笔记..."

              maxlength="500"

              show-word-limit

            />

            <el-button

              size="small"

              type="primary"

              style="margin-top:8px;"

              :loading="noteSaving"

              @click="saveNote"

            >保存笔记</el-button>

          </div>



        </div>



        <div class="detail-right">

          <div class="question-block">

            <div class="block-title"><i class="el-icon-picture-outline" style="margin-right:6px;"></i>上传手写笔记图片</div>

            <div class="upload-hint">上传你手写的笔记照片，帮助你整理思路和记忆要点</div>

            <input type="file" accept="image/*" multiple ref="noteFileInput" style="display:none" @change="onNoteFileChange" />

            <el-button size="small" @click="$refs.noteFileInput.click()" :loading="noteUploading" class="upload-trigger-btn">

              <i class="el-icon-upload2"></i> {{ noteImages.length > 0 ? '继续添加' : '选择笔记图片' }}

            </el-button>

            <div v-if="noteImages && noteImages.length > 0" class="upload-preview-grid">

              <div v-for="(img, idx) in noteImages" :key="'note-'+idx" class="upload-preview-item">

                <img :src="resolveImageUrl(img)" alt="笔记图片" />

                <div class="upload-preview-overlay">

                  <el-button size="mini" type="danger" icon="el-icon-delete" circle @click="removeNoteImage(idx)"></el-button>

                </div>

              </div>

            </div>

            <div v-else class="simple-empty-state">暂无笔记图片</div>

          </div>



          <div class="question-block">

            <div class="block-title"><i class="el-icon-document" style="margin-right:6px;"></i>上传做题过程图片</div>

            <div class="upload-hint">上传你的做题草稿或解题过程，便于回顾复习</div>

            <input type="file" accept="image/*" multiple ref="detailFileInput" style="display:none" @change="onDetailFileChange" />

            <el-button size="small" @click="$refs.detailFileInput.click()" :loading="detailUploading" class="upload-trigger-btn">

              <i class="el-icon-upload2"></i> {{ detailUploadedImages.length > 0 ? '继续添加' : '选择过程图片' }}

            </el-button>

            <div v-if="detailUploadedImages && detailUploadedImages.length > 0" class="upload-preview-grid">

              <div v-for="(img, idx) in detailUploadedImages" :key="'proc-'+idx" class="upload-preview-item">

                <img :src="resolveImageUrl(img)" alt="做题过程图片" />

                <div class="upload-preview-overlay">

                  <el-button size="mini" type="danger" icon="el-icon-delete" circle @click="removeDetailImage(idx)"></el-button>

                </div>

              </div>

            </div>

            <div v-else class="simple-empty-state">暂无过程图片</div>

          </div>

        </div>

      </div>



      <div v-else class="simple-empty-state mt16">暂无详情数据</div>



      <span slot="footer" class="dialog-footer">

        <el-button

          v-if="current && current.status === 'pending'"

          type="warning"

          @click="startCorrection"

          style="margin-right:8px;"

        ><i class="el-icon-edit"></i> 立即纠错</el-button>

        <el-button @click="showDetailDialog = false">关闭</el-button>

      </span>

    </el-dialog>



    <!-- 纠错答题弹窗 -->

    <el-dialog

      title="错题纠错"

      :visible.sync="showCorrectionDialog"

      width="720px"

      custom-class="correction-dialog"

      :close-on-click-modal="false"

      :before-close="onCorrectionDialogClose"

    >

      <div v-if="correctionLoading" style="text-align:center;padding:40px 0;">

        <i class="el-icon-loading" style="font-size:28px;"></i>

        <div style="margin-top:12px;color:#909399;">加载中...</div>

      </div>



      <div v-else-if="correctionPhase === 'wrong'" class="correction-panel">

        <div class="correction-phase-tip">

          <el-tag type="danger">第一阶段</el-tag>

          <span style="margin-left:8px;">先订正这道错题，答对后进入相似题练习</span>

        </div>



        <div class="correction-q-meta" v-if="correctionQuestion">

          <el-tag size="mini" type="success" v-if="correctionQuestion.year">{{ correctionQuestion.year }}</el-tag>

          <el-tag size="mini" v-if="correctionQuestion.difficulty" :type="getDifficultyType(correctionQuestion.difficulty)" style="margin-left:4px;">难度 {{ formatDifficulty(correctionQuestion.difficulty) }}</el-tag>

          <span v-if="current && current.knowledge" style="margin-left:8px;font-size:12px;color:#909399;">{{ resolveKnowledgeName(current.knowledge) }}</span>

        </div>



        <div class="correction-content" v-mathjax v-html="formatContent(correctionQuestion && (correctionQuestion.contentCn || correctionQuestion.content) || '')"></div>

        <!-- 题干图片 -->
        <div v-if="correctionQuestion && getQuestionImages(correctionQuestion).length" style="margin:10px 0;">
          <div v-for="(img, imgIdx) in getQuestionImages(correctionQuestion)" :key="'cq-img-' + imgIdx" style="margin-bottom:8px;">
            <img :src="resolveImageUrl(img)" style="max-width:100%;border:1px solid #eee;border-radius:4px;" @error="$event.target.style.display='none'" />
          </div>
        </div>

        <div class="correction-options" v-if="correctionOptions && correctionOptions.length">

          <el-radio-group v-model="correctionAnswer">

            <el-radio

              v-for="(opt, idx) in correctionOptions"

              :key="idx"

              :label="getOptionKey(opt, idx)"

              class="correction-opt"

              :disabled="correctionAnswered"

            >

              <span>{{ getOptionKey(opt, idx) }}.</span>

              <span v-mathjax v-html="formatContent(getOptionText(opt))"></span>

            </el-radio>

          </el-radio-group>

        </div>

        <div v-else style="margin-top:8px;">

          <el-input v-model="correctionAnswer" placeholder="请输入答案" maxlength="20" style="width:200px;" :disabled="correctionAnswered" />

        </div>



        <div v-if="correctionAnswered" class="correction-result">

          <div v-if="correctionIsCorrect" class="correction-ok"><i class="el-icon-check"></i> 回答正确！正在为你推荐相似题...</div>

          <div v-else class="correction-bad">

            <i class="el-icon-close"></i> 回答错误，正确答案：<strong>{{ correctionQuestion && correctionQuestion.answer }}</strong>，请重新作答

          </div>

        </div>



        <div v-if="correctionAnswered && correctionQuestion && (correctionQuestion.analysisCn || correctionQuestion.analysis)" class="correction-analysis">

          <div class="correction-analysis-title">解析</div>

          <div v-mathjax v-html="formatContent(correctionQuestion.analysisCn || correctionQuestion.analysis)"></div>

        </div>



        <div class="correction-upload" style="margin-top:12px;">

          <span style="font-size:12px;color:#909399;">上传做题图片（可选）：</span>

          <input type="file" accept="image/*" ref="correctionFileInput" style="display:none" @change="onCorrectionFileChange" />

          <el-button size="mini" @click="$refs.correctionFileInput.click()" :loading="correctionUploading">

            <i class="el-icon-upload2"></i> 选择图片

          </el-button>

          <span v-if="correctionImageFile" style="margin-left:8px;font-size:12px;color:#67c23a;">{{ correctionImageFile.name }}</span>

          <el-button v-if="correctionImageFile" size="mini" type="text" style="color:#f56c6c;" @click="correctionImageFile=null">移除</el-button>

        </div>



        <div class="correction-actions">

          <el-button

            v-if="!correctionAnswered || !correctionIsCorrect"

            type="primary"

            :disabled="!correctionAnswer"

            :loading="correctionSubmitting"

            @click="submitCorrectionAnswer"

          >提交答案</el-button>

        </div>

      </div>



      <div v-else-if="correctionPhase === 'similar'" class="correction-panel">

        <div class="correction-phase-tip">

          <el-tag type="primary">第二阶段</el-tag>

          <span style="margin-left:8px;">

            相似题练习（{{ correctionSimilarIdx + 1 }} / {{ correctionSimilars.length }}），全部作答后本题标记为已订正

          </span>

        </div>



        <template v-if="correctionSimilars[correctionSimilarIdx]">

          <div class="correction-q-meta">

            <el-tag size="mini" type="info">相似题</el-tag>

            <el-tag size="mini" v-if="correctionSimilars[correctionSimilarIdx].year" type="success" style="margin-left:4px;">年份：{{ correctionSimilars[correctionSimilarIdx].year }}</el-tag>

            <el-tag size="mini" v-if="correctionSimilars[correctionSimilarIdx].difficulty" :type="getDifficultyType(correctionSimilars[correctionSimilarIdx].difficulty)" style="margin-left:4px;">难度：{{ formatDifficulty(correctionSimilars[correctionSimilarIdx].difficulty) }}</el-tag>

            <el-tag size="mini" v-if="correctionSimilars[correctionSimilarIdx].source" style="margin-left:4px;">来源：{{ correctionSimilars[correctionSimilarIdx].source }}</el-tag>

          </div>



          <div class="correction-content" v-mathjax v-html="formatContent(getSimilarContent(correctionSimilars[correctionSimilarIdx]))"></div>

          <!-- 相似题题干图片 -->
          <div v-if="getQuestionImages(correctionSimilars[correctionSimilarIdx]).length" style="margin:10px 0;">
            <div v-for="(img, imgIdx) in getQuestionImages(correctionSimilars[correctionSimilarIdx])" :key="'cs-img-' + imgIdx" style="margin-bottom:8px;">
              <img :src="resolveImageUrl(img)" style="max-width:100%;border:1px solid #eee;border-radius:4px;" @error="$event.target.style.display='none'" />
            </div>
          </div>

          <div class="correction-options" v-if="getSimilarOptions(correctionSimilars[correctionSimilarIdx]).length">

            <el-radio-group v-model="correctionAnswer">

              <el-radio

                v-for="(opt, idx) in getSimilarOptions(correctionSimilars[correctionSimilarIdx])"

                :key="idx"

                :label="getOptionKey(opt, idx)"

                class="correction-opt"

                :disabled="correctionAnswered"

              >

                <span>{{ getOptionKey(opt, idx) }}.</span>

                <span v-mathjax v-html="formatContent(getOptionText(opt))"></span>

              </el-radio>

            </el-radio-group>

          </div>

          <div v-else style="margin-top:8px;">

            <el-input v-model="correctionAnswer" placeholder="请输入答案" maxlength="20" style="width:200px;" :disabled="correctionAnswered" />

          </div>



          <div v-if="correctionAnswered" class="correction-result">

            <div v-if="correctionIsCorrect" class="correction-ok"><i class="el-icon-check"></i> 回答正确！</div>

            <div v-else class="correction-bad">

              <i class="el-icon-close"></i> 回答错误，正确答案：<strong>{{ getSimilarAnswer(correctionSimilars[correctionSimilarIdx]) }}</strong>

            </div>

          </div>



          <div v-if="correctionAnswered && getSimilarAnalysis(correctionSimilars[correctionSimilarIdx])" class="correction-analysis">

            <div class="correction-analysis-title">解析</div>

            <div v-mathjax v-html="formatContent(getSimilarAnalysis(correctionSimilars[correctionSimilarIdx]))"></div>

          </div>



          <div class="correction-upload" style="margin-top:12px;">

            <span style="font-size:12px;color:#909399;">上传做题图片（可选）：</span>

            <input type="file" accept="image/*" ref="similarFileInput" style="display:none" @change="onCorrectionFileChange" />

            <el-button size="mini" @click="$refs.similarFileInput.click()" :loading="correctionUploading" :disabled="correctionAnswered">

              <i class="el-icon-upload2"></i> 选择图片

            </el-button>

            <span v-if="correctionImageFile" style="margin-left:8px;font-size:12px;color:#67c23a;">{{ correctionImageFile.name }}</span>

            <el-button v-if="correctionImageFile && !correctionAnswered" size="mini" type="text" style="color:#f56c6c;" @click="correctionImageFile=null">移除</el-button>

          </div>



          <div class="correction-actions">

            <el-button

              v-if="!correctionAnswered"

              type="primary"

              :disabled="!correctionAnswer"

              :loading="correctionSubmitting"

              @click="submitSimilarAnswer"

            >提交答案</el-button>

            <el-button

              v-else

              type="success"

              :loading="correctionSubmitting"

              @click="nextSimilarOrFinish"

            >{{ correctionSimilarIdx + 1 < correctionSimilars.length ? '下一题' : '完成纠错' }}</el-button>

          </div>

        </template>

      </div>



      <div v-else-if="correctionPhase === 'report'" class="correction-panel">

        <div class="correction-phase-tip">

          <el-tag type="info">相似题报告</el-tag>

          <span style="margin-left:8px;">回顾本次相似题练习情况，确认后完成纠错</span>

        </div>



        <div v-if="!correctionSimilarResults.length" style="color:#909399;margin-top:12px;">暂无相似题作答记录</div>

        <div v-else>

          <div

            v-for="(r, idx) in correctionSimilarResults"

            :key="r.quesId || idx"

            style="border:1px solid #ebeef5;border-radius:6px;padding:12px;margin-top:12px;"

          >

            <div style="display:flex;align-items:center;gap:8px;flex-wrap:wrap;">

              <el-tag size="mini" type="info">第 {{ idx + 1 }} 题</el-tag>

              <el-tag size="mini" :type="r.isRight ? 'success' : 'danger'">{{ r.isRight ? '正确' : '错误' }}</el-tag>

              <span style="font-size:12px;color:#909399;">你的答案：<strong>{{ r.userAnswer || '-' }}</strong></span>

              <span style="font-size:12px;color:#909399;">正确答案：<strong>{{ r.answer || '-' }}</strong></span>

            </div>



            <div style="margin-top:10px;" v-if="r.content">

              <div style="font-weight:600;margin-bottom:6px;">题干</div>

              <div v-mathjax v-html="formatContent(r.content)"></div>

            </div>



            <div style="margin-top:10px;" v-if="r.analysis">

              <div style="font-weight:600;margin-bottom:6px;">解析</div>

              <div v-mathjax v-html="formatContent(r.analysis)"></div>

            </div>

          </div>

        </div>



        <div class="correction-actions" style="margin-top:16px;">

          <el-button type="primary" :loading="correctionSubmitting" @click="finishCorrection">完成纠错</el-button>

        </div>

      </div>



      <div v-else-if="correctionPhase === 'done'" class="correction-done">

        <i class="el-icon-circle-check" style="font-size:48px;color:#67c23a;"></i>

        <div style="margin-top:12px;font-size:16px;font-weight:600;">纠错完成！</div>

        <div style="margin-top:6px;color:#909399;">本题已标记为已订正</div>

        <el-button type="primary" style="margin-top:20px;" @click="showCorrectionDialog = false">关闭</el-button>

      </div>



      <span slot="footer" v-if="correctionPhase !== 'done'"></span>

    </el-dialog>

  </div>

</template>



<script>

import { getWrongRecordsByUserId, updateRecord, addRecord } from '@/api/userQuestionRecord'

import { getQuestionById, getSimilarQuestions } from '@/api/courseQuestion'

import { getTokenInfo } from '@/utils/jwtUtils'

import { getMinioUrl } from '@/utils/minio'

import { uploadToBucket, deleteFrom } from '@/api/file'

import { getProgressPaging, updateProgressFinished, getSchemeByUserIdAndRepoId, updateSchemeFinishedIds } from '@/api/studyPlan'

import { userStatusAdd } from '@/api/userStatus'

import { batchGetGeneralKnowledgeNames } from '@/api/knowledge'

import katex from 'katex'

import 'katex/dist/katex.min.css'



export default {

  name: 'WrongQuestions',

  directives: {

    mathjax: {

      inserted(el) {

        setTimeout(() => {

          try {

            if (window && window.MathJax && typeof window.MathJax.typesetPromise === 'function') {

              if (typeof window.MathJax.typesetClear === 'function') window.MathJax.typesetClear([el])

              window.MathJax.typesetPromise([el]).catch(() => {})

            }

          } catch (_) {}

        }, 50)

      },

      componentUpdated(el) {

        setTimeout(() => {

          try {

            if (window && window.MathJax && typeof window.MathJax.typesetPromise === 'function') {

              if (typeof window.MathJax.typesetClear === 'function') window.MathJax.typesetClear([el])

              window.MathJax.typesetPromise([el]).catch(() => {})

            }

          } catch (_) {}

        }, 50)

      }

    }

  },

  data() {

    return {

      loading: false,

      rows: [],

      filteredRows: [],

      current: null,

      currentQuestion: null,

      resources: [],

      statusFilter: '',

      repoFilter: '',

      repoOptions: [],

      knowledgeOptions: [],

      knowledgeFilter: '',

      wrongCountFilter: '',

      dateRange: [],

      pageSize: 8,

      currentPage: 1,

      editNote: '',

      savingNote: false,

      noteSaving: false,

      // 图片上传相关

      uploadedImages: [], // 已上传的图片列表 [{url, path, name}]

      uploading: false,

      savingImages: false, // 保存图片状态

      // 二级弹窗控制

      showDetailDialog: false,

      // 是否仅显示今日错题（由路由参数 today=1 触发）

      todayOnly: false,

      // 表格自适应高度

      tableHeight: 480,

      // 纠错弹窗相关

      showCorrectionDialog: false,

      correctionLoading: false,

      correctionSubmitting: false,

      correctionPhase: 'wrong', // 'wrong' | 'similar' | 'report' | 'done'

      correctionQuestion: null, // 完整题目详情

      correctionOptions: [],

      correctionAnswer: '',

      correctionAnswered: false,

      correctionIsCorrect: false,

      correctionSimilars: [],

      correctionSimilarIdx: 0,

      correctionLangMode: 'cn',

      correctionSimilarResults: [],

      correctionWrongResult: null,

      // 纠错图片上传

      correctionImageFile: null,

      correctionUploading: false,

      // 知识点ID→名称映射

      knowledgeNameMap: {},

      // 详情弹窗的笔记编辑

      detailEditNote: '',

      detailNoteSaving: false,

      // 详情弹窗的图片上传 - 手写笔记图片

      noteUploading: false,

      noteImages: [],

      // 详情弹窗的图片上传 - 做题过程图片（使用原 images 字段）

      detailUploading: false,

      detailUploadedImages: []

    }

  },

  computed: {

    pagedRows() {

      const start = (this.currentPage - 1) * this.pageSize

      return this.filteredRows.slice(start, start + this.pageSize)

    }

  },

  created() {

    const q = (this.$route && this.$route.query) || {}

    this.todayOnly = q && (q.today === 1 || q.today === '1' || q.today === true)

    if (q && (q.status === 'pending' || q.status === 'reviewed')) {

      this.statusFilter = q.status

    }

    this.fetchWrongRecords()

  },

  mounted() {

    // 进入页面：自动收起左侧导航栏（向左隐藏）

    try {

      this.$store && this.$store.dispatch && this.$store.dispatch('app/closeSideBar', { withoutAnimation: true })

    } catch (e) { /* no-op */ }

    // 计算表格高度并监听窗口变化

    this.$nextTick(() => {

      this.updateTableHeight()

      window.addEventListener('resize', this.updateTableHeight)

    })

  },

  beforeDestroy() {

    // 离开页面：还原侧边栏状态

    try {

      this.$store && this.$store.dispatch && this.$store.dispatch('app/openSideBar', { withoutAnimation: true })

    } catch (e) { /* no-op */ }

    window.removeEventListener('resize', this.updateTableHeight)

  },

  methods: {

    // 计算表格高度，使其占满可视区域

    updateTableHeight() {

      const vh = window.innerHeight || document.documentElement.clientHeight || 800

      const containerPadding = 32 // 上下 padding 约 16+16

      const toolbar = (this.$el && this.$el.querySelector('.toolbar')) ? this.$el.querySelector('.toolbar').offsetHeight : 0

      const pagination = 56 // 分页区域和间距预估高度

      const extra = 24 // 其他空隙

      const h = vh - (containerPadding + toolbar + pagination + extra)

      this.tableHeight = Math.max(320, h)

      // 根据高度动态计算每页条数，尽量铺满表格

      const headerH = 44

      const rowH = 86

      const rows = Math.max(5, Math.floor((this.tableHeight - headerH) / rowH))

      if (rows !== this.pageSize) {

        this.pageSize = rows

        this.currentPage = 1

        // 触发重新分页

        this.applyFilters()

      }

    },

    resolveKnowledgeName(val) {

      if (val == null || val === '' || val === '-') return val || '-'

      const raw = String(val).trim()

      if (!raw || raw === '-') return raw

      // 如果全是数字和分隔符，说明是 ID 列表

      if (/^[0-9,，\s]+$/.test(raw)) {

        const ids = raw.split(/[,，\s]+/).filter(x => x)

        const nameMap = this.knowledgeNameMap || {}

        return ids.map(id => nameMap[String(id)] || id).join('、')

      }

      return raw

    },

    getRowSourceLabel(row) {

      const r = row || {}

      const title = String(r.title || '').trim()

      const source = String(r.source || '').trim()

      let year = ''

      const fromTitle = title.match(/(19|20)\d{2}/)

      if (fromTitle && fromTitle[0]) year = fromTitle[0]

      const parts = []

      if (title) parts.push(title)

      if (source) parts.push(source)

      if (year && !parts.join(' ').includes(year)) parts.unshift(year)

      return parts.length ? parts.join(' ') : '错题记录'

    },

    formatRowTime(val) {

      if (!val || val === '-') return '时间未知'

      const d = new Date(val)

      if (isNaN(d.getTime())) return String(val)

      const y = d.getFullYear()

      const m = String(d.getMonth() + 1).padStart(2, '0')

      const day = String(d.getDate()).padStart(2, '0')

      const hh = String(d.getHours()).padStart(2, '0')

      const mm = String(d.getMinutes()).padStart(2, '0')

      return `${y}-${m}-${day} ${hh}:${mm}`

    },



    async ensureKnowledgeNames(values) {

      try {

        if (!this.knowledgeNameMap) this.knowledgeNameMap = {}

        const list = Array.isArray(values) ? values : [values]

        const ids = list

          .flatMap(v => (v == null ? [] : String(v).split(/[,，\s]+/)))

          .map(x => String(x).trim())

          .filter(x => x && /^\d+$/.test(x))

        const unique = Array.from(new Set(ids)).filter(id => !(this.knowledgeNameMap || {})[id])

        if (!unique.length) return

        const resp = await batchGetGeneralKnowledgeNames(unique)

        const data = resp?.data?.data ?? resp?.data ?? resp

        if (Array.isArray(data)) {

          data.forEach(item => {

            const id = item && (item.id ?? item.knowledgeId)

            const name = item && (item.content ?? item.name ?? item.title)

            if (id != null && name != null) this.$set(this.knowledgeNameMap, String(id), String(name))

          })

        } else if (data && typeof data === 'object' && !Array.isArray(data)) {

          try {

            Object.keys(data).forEach(k => {

              if (data[k] != null) this.$set(this.knowledgeNameMap, String(k), String(data[k]))

            })

          } catch (err) {

            console.warn('解析知识点映射对象失败:', err)

          }

        }

      } catch (e) {

        console.warn('获取知识点名称失败:', e)

      }

    },



    // 返回 AMC 备考中心

    goBackToAMCCenter() {

      const q = this.$route?.query || {}

      const query = {}

      if (q.repoId) query.repoId = q.repoId

      if (q.level) query.level = q.level

      if (q.courseTypeId) query.courseTypeId = q.courseTypeId

      if (q.courseTypeCode) query.courseTypeCode = q.courseTypeCode

      this.$router.push({ path: '/amc-course', query })

    },

    // 拉取用户错题记录

    async fetchWrongRecords() {

      try {

        this.loading = true

        const user = getTokenInfo && getTokenInfo()

        const studentId = user?.id

        const repoId = this.$route?.query?.repoId || this.$route?.params?.repoId || null



        console.log('开始获取错题记录(按用户ID错题接口):', { user, studentId, repoId })

        console.log('调用的接口: getWrongByUserId(userId, repoId)')



        const res = await getWrongRecordsByUserId(studentId, repoId)

        console.log('错题接口响应:', res)

        console.log('接口URL: /user-question-records/user/' + studentId + '/wrong' + (repoId ? ('?repoId=' + repoId) : ''))



        const list = Array.isArray(res?.data) ? res.data : (Array.isArray(res) ? res : [])

        console.log('解析后的错题列表:', list)



        const rows = list.map(item => {

          console.log('处理错题记录:', item)

          const reviewRaw = item.isReview ?? item.is_review ?? item.reviewed ?? item.reviewStatus

          const reviewStatusRaw = String(item.status ?? item.reviewStatus ?? '').trim().toLowerCase()

          const isReviewed = reviewRaw === 1

            || reviewRaw === '1'

            || reviewRaw === true

            || reviewRaw === 'true'

            || reviewStatusRaw === 'reviewed'

            || reviewStatusRaw === 'done'

            || reviewStatusRaw === 'finished'

          return {

            id: item.id,

            userId: item.userId,

            quesId: item.quesId,

            homeworkId: item.homeworkId, // 可能无

            submitId: item.submitId, // 可能无

            time: item.time || item.createTime || item.updateTime || '-',

            knowledge: item.knowledge || '-',

            type: item.type || '-',

            reason: item.judge || item.reason || '',

            status: isReviewed ? 'reviewed' : 'pending',

            wrongCount: Number(item.wrongCount ?? item.wrong_count ?? item.wrongTimes ?? item.wrong_times ?? item.count ?? 1) || 1,

            userAnswer: item.userAnswer || '',

            quesContent: item.quesContent || item.content || '',

            note: item.mynote || item.note || '',

            correctAnswer: item.correctAnswer || item.answer || '',

            title: item.title || item.questionTitle || '',

            source: item.source || item.questionSource || '',

            images: item.images || '', // 图片列表JSON字符串

            aiAnalysis: item.aiAnalysis || '', // AI分析结果JSON字符串

            // 保存原始数据用于调试

            rawData: item

          }

        })



        this.rows = rows

        // 生成知识点选项（仅父级）

        const set = new Set()

        rows.forEach(r => {

          this.extractParents(String(r.knowledge || '')).forEach(p => set.add(p))

        })

        this.knowledgeOptions = Array.from(set)

        // 解析知识点选项名称

        const knowledgeIds = Array.from(set).filter(k => /^\d+$/.test(k))

        if (knowledgeIds.length > 0) {

          await this.ensureKnowledgeNames(knowledgeIds)

          this.knowledgeOptions = Array.from(set).map(k => this.resolveKnowledgeName(k))

        }

        // 批量获取知识点名称

        const allKnowledge = rows.map(r => r.knowledge).filter(v => v && v !== '-')

        await this.ensureKnowledgeNames(allKnowledge)

        // 拉取完成后根据当前筛选条件（含今日过滤）应用过滤

        this.applyFilters()



        // 调试日志

        console.log('错题集数据加载完成:', {

          totalCount: rows.length,

          firstItem: rows[0] || null,

          sampleData: rows.slice(0, 3).map(r => ({

            id: r.id,

            userId: r.userId,

            quesId: r.quesId,

            homeworkId: r.homeworkId,

            submitId: r.submitId,

            homeworkName: r.rawData?.homeworkName,

            courseName: r.rawData?.courseName

          }))

        })



        if (rows.length === 0) {

          console.warn('没有找到错题记录，可能的原因：')

          console.warn('1. 学生ID不正确:', studentId)

          console.warn('2. 视图数据为空')

          console.warn('3. 接口返回格式异常')

          this.$message.warning('暂无错题记录')

        }



        // 不再自动打开第一条详情，由用户点击后再打开

      } catch (e) {

        console.warn('获取错题记录失败:', e)

        this.$message.error('获取错题记录失败')

      } finally {

        this.loading = false

      }

    },



    applyFilters() {

      const kFilter = (this.knowledgeFilter || '').trim()

      const wcFilter = this.wrongCountFilter

      const hasRange = Array.isArray(this.dateRange) && this.dateRange.length === 2 && this.dateRange[0] && this.dateRange[1]

      const startTime = hasRange ? new Date(this.dateRange[0]).getTime() : null

      const endTime = hasRange ? new Date(this.dateRange[1]).getTime() + 24 * 60 * 60 * 1000 - 1 : null

      this.filteredRows = this.rows.filter(r => {

        const statusOk = this.statusFilter ? r.status === this.statusFilter : true

        const repoOk = true

        const dateOkToday = this.todayOnly ? this.isToday(r.time) : true

        const dateOkRange = hasRange ? (() => {

          const t = new Date(r.time).getTime()

          return !isNaN(t) && t >= startTime && t <= endTime

        })() : true

        const dateOk = dateOkToday && dateOkRange

        const parents = this.extractParents(String(r.knowledge || ''))

        const resolvedParents = parents.map(p => this.resolveKnowledgeName(p))

        const knowledgeOk = kFilter ? (parents.includes(kFilter) || resolvedParents.includes(kFilter)) : true

        const wrongCountOk = wcFilter ? (wcFilter === '4+' ? Number(r.wrongCount || 0) >= 4 : Number(r.wrongCount || 0) === Number(wcFilter)) : true

        return statusOk && repoOk && knowledgeOk && wrongCountOk && dateOk

      })

      this.currentPage = 1

    },

    // 从“代数-基础运算, 代数-乘法, 排列组合-阶乘”这样的串中提取父级：['代数','排列组合']

    extractParents(knowledgeStr) {

      if (!knowledgeStr) return []

      const tokens = String(knowledgeStr)

        .split(/[,，]/)

        .map(s => s.trim())

        .filter(Boolean)

      const parents = new Set()

      tokens.forEach(tok => {

        const p = tok.split(/[-—]/)[0].trim()

        if (p) parents.add(p)

      })

      return Array.from(parents)

    },



    // 判断给定时间戳是否为今天

    isToday(ts) {

      if (!ts || ts === '-') return false

      const d = new Date(ts)

      if (isNaN(d.getTime())) return false

      const now = new Date()

      return d.getFullYear() === now.getFullYear() && d.getMonth() === now.getMonth() && d.getDate() === now.getDate()

    },



    tableRowClassName({ row }) {

      if (!row) return ''

      return row.status === 'reviewed' ? 'row-reviewed' : 'row-pending'

    },



    async loadQuestionDetail(quesId) {

      if (!quesId) return null

      try {

        const resp = await getQuestionById(quesId)

        const data = resp?.data?.data ?? resp?.data ?? resp

        if (!data) return null

        // 归一化字段：后端返回 contentCn/optionsCn，模板使用 content/options

        if (!data.content && data.contentCn) data.content = data.contentCn

        if (!data.content && data.contentEn) data.content = data.contentEn

        if (!data.options && data.optionsCn) data.options = data.optionsCn

        if (!data.options && data.optionsEn) data.options = data.optionsEn

        if (!data.analysis && data.analysisCn) data.analysis = data.analysisCn

        if (!data.analysis && data.analysisEn) data.analysis = data.analysisEn

        if (!data.correctAnswer && data.answer) data.correctAnswer = data.answer

        if (!data.answerCn && data.answer) data.answerCn = data.answer

        if (!data.answerEn && data.answer) data.answerEn = data.answer

        return data

      } catch (e) {

        console.warn('获取题目详情失败:', e)

        return null

      }

    },



    async onRowClick(row) {

      console.log('点击行:', row)



      this.current = row

      this.editNote = row.note || ''

      this.noteImages = []

      this.detailUploadedImages = []



      // 加载手写笔记图片（独立字段 noteImages）

      const rawNoteImages = row.rawData?.noteImages || ''

      try {

        this.noteImages = rawNoteImages

          ? (typeof rawNoteImages === 'string' ? JSON.parse(rawNoteImages) : (Array.isArray(rawNoteImages) ? rawNoteImages : []))

          : []

      } catch (e) { this.noteImages = [] }



      // 加载做题过程图片（使用原 images 字段）

      const rawImages = row.rawData?.images || row.images || ''

      try {

        this.detailUploadedImages = rawImages

          ? (typeof rawImages === 'string' ? JSON.parse(rawImages) : (Array.isArray(rawImages) ? rawImages : []))

          : []

      } catch (e) { this.detailUploadedImages = [] }



      // 请求完整的题目详情

      if (row.quesId) {

        const questionDetail = await this.loadQuestionDetail(row.quesId)

        if (questionDetail) {

          this.currentQuestion = questionDetail

          console.log('加载题目详情成功:', questionDetail)

        } else {

          // 如果获取详情失败，使用错题记录中的数据作为后备

          console.warn('获取题目详情失败，使用错题记录中的数据')

          this.currentQuestion = {

            content: row.quesContent || row.rawData?.quesContent || '',

            answer: row.correctAnswer || row.rawData?.correctAnswer || '',

            options: this.parseOptions(row.rawData?.options || row.rawData?.optionsStr || ''),

            title: row.title || row.rawData?.title || '',

            source: row.source || row.rawData?.source || '',

            analysis: row.rawData?.analysis || '',

            image: row.rawData?.image || row.rawData?.imagePaths || null,

            imagePaths: row.rawData?.imagePaths || null

          }

        }

      } else {

        // 如果没有题目ID，使用错题记录中的数据

        this.currentQuestion = {

          content: row.quesContent || row.rawData?.quesContent || '',

          answer: row.correctAnswer || row.rawData?.correctAnswer || '',

          options: this.parseOptions(row.rawData?.options || row.rawData?.optionsStr || ''),

          title: row.title || row.rawData?.title || '',

          source: row.source || row.rawData?.source || '',

          analysis: row.rawData?.analysis || '',

          image: row.rawData?.image || row.rawData?.imagePaths || null,

          imagePaths: row.rawData?.imagePaths || null

        }

      }



      this.showDetailDialog = true



      // 触发 MathJax 渲染

      this.detailTypeset()

    },



    onRowDblClick(row) {

      this.onRowClick(row)

    },



    loadResources(row) {

      // 占位：根据题目/知识点生成相关资料（可扩展成接口）

      this.resources = []

    },



    async saveNote() {

      if (!this.current) {

        this.$message.warning('请先选择一条记录')

        return

      }

      if (!this.current.userId || !this.current.quesId) {

        this.$message.error('缺少必要的用户ID或题目ID')

        return

      }

      this.savingNote = true

      try {

        const payload = {

          id: this.current.id,

          userId: this.current.userId,

          quesId: this.current.quesId,

          mynote: this.editNote

        }

        await updateRecord(payload)

        this.$message.success('保存成功')

        // 同步到当前行

        this.current.note = this.editNote

        // 更新列表中的数据

        const idx = this.rows.findIndex(r => (r.id || r.recordId) === this.current.id)

        if (idx >= 0) this.rows[idx].note = this.editNote

        this.applyFilters()

      } catch (e) {

        console.error('保存笔记失败:', e)

        this.$message.error('保存笔记失败')

      } finally {

        this.savingNote = false

      }

    },



    async markReviewed() {

      if (!this.current) return

      if (!this.current.userId || !this.current.quesId) {

        this.$message.error('缺少必要的用户ID或题目ID')

        return

      }

      try {

        const toReviewed = this.current.status === 'reviewed' ? 0 : 1

        await updateRecord({

          id: this.current.id,

          userId: this.current.userId,

          quesId: this.current.quesId,

          isReview: toReviewed

        })

        this.current.status = toReviewed === 1 ? 'reviewed' : 'pending'

        const idx = this.rows.findIndex(r => r.id === this.current.id)

        if (idx !== -1) this.$set(this.rows, idx, { ...this.rows[idx], status: this.current.status })

        this.$message.success(toReviewed === 1 ? '已标记为已订正' : '已标记为未订正')

      } catch (e) {

        console.warn('标记订正状态失败:', e)

        this.$message.error('更新订正状态失败')

      }

    },



    renderText(text) {

      if (!text) return ''

      const input = this.escapeHtml(this.normalizeLatexInput(String(text)

        .replace(/\r\n/g, '\n')

        .replace(/\\\\\(/g, '\\(')

        .replace(/\\\\\)/g, '\\)')

        .replace(/\\\\\[/g, '\\[')

        .replace(/\\\\\]/g, '\\]')))

      if (katex && typeof katex.renderToString === 'function') {

        let html = input

        html = html.replace(/\\\[([\s\S]+?)\\\]/g, (_, expr) => this.renderKatex(expr, true))

        html = html.replace(/\$\$([\s\S]+?)\$\$/g, (_, expr) => this.renderKatex(expr, true))

        html = html.replace(/\\\(([\s\S]+?)\\\)/g, (_, expr) => this.renderKatex(expr, false))

        html = html.replace(/\$([^$\n]+?)\$/g, (_, expr) => this.renderKatex(expr, false))

        html = this.renderMarkdownImages(html)

        return html.replace(/\n/g, '<br>')

      }

      return this.renderMarkdownImages(input).replace(/\n/g, '<br>')

    },



    renderMarkdownImages(text) {

      if (!text) return ''

      return String(text).replace(/!\[([^\]]*)\]\(([^)]+)\)/g, (_, alt, path) => {

        const src = this.resolveImageUrl(path)

        if (!src) return ''

        return `<img src="${src}" alt="${alt || '图片'}" style="max-width:100%; border:1px solid #eee; border-radius:4px; margin:8px 0;" />`

      })

    },

    renderKatex(expr, displayMode) {

      try {

        let formula = this.decodeHtmlEntities(this.normalizeLatexInput(String(expr || '').trim().replace(/\\\\/g, '\\')))

        if (window && typeof window.fixLatexNotation === 'function') {

          formula = window.fixLatexNotation(formula)

        }

        return katex.renderToString(formula, {

          throwOnError: false,

          displayMode: !!displayMode,

          strict: false,

          trust: true

        })

      } catch (_) {

        return this.escapeHtml(displayMode ? `\\[${expr}\\]` : `\\(${expr}\\)`)

      }

    },

    normalizeLatexInput(text) {

      if (!text) return ''

      return String(text)

        .replace(/(^|[^\\])frac\s*\{/g, '$1\\frac{')

        .replace(/(^|[^\\])sqrt\s*\{/g, '$1\\sqrt{')

        .replace(/(^|[^\\])cdot\b/g, '$1\\cdot')

        .replace(/(^|[^\\])times\b/g, '$1\\times')

    },

    escapeHtml(text) {

      if (text == null) return ''

      return String(text)

        .replace(/&/g, '&amp;')

        .replace(/</g, '&lt;')

        .replace(/>/g, '&gt;')

    },

    decodeHtmlEntities(text) {

      if (text == null) return ''

      return String(text)

        .replace(/&lt;/g, '<')

        .replace(/&gt;/g, '>')

        .replace(/&amp;/g, '&')

        .replace(/&quot;/g, '"')

        .replace(/&#39;/g, "'")

    },

    parseAiAnalysis(aiAnalysisStr) {

      if (!aiAnalysisStr) return null

      try {

        const parsed = JSON.parse(aiAnalysisStr)

        if (parsed && parsed.ai_analysis) return parsed

        return null

      } catch (e) {

        return null

      }

    },

    getQuestionYear(question) {

      if (!question) return ''

      if (question.year) return String(question.year)

      // 处理相似题推荐接口返回的 type 字段（直接是年份）

      if (question.type) {

        const typeStr = String(question.type)

        // 如果 type 本身就是年份格式（如 "1993"）

        if (/^(19|20)\d{2}$/.test(typeStr)) return typeStr

      }

      const num = question.number ? String(question.number) : ''

      if (!num) return ''

      const m = num.match(/(19|20)\d{2}/)

      return m ? m[0] : ''

    },

    // 解析选项字符串为数组

    parseOptions(optionsStr) {

      if (!optionsStr) return []

      if (Array.isArray(optionsStr)) return optionsStr

      // 按分号分割选项

      return optionsStr.split(';').map(opt => opt.trim()).filter(opt => opt)

    },

    // 获取题目的所有图片路径

    getQuestionImages(question) {

      const images = []

      this.parseImageField(question.imagePaths).forEach(img => {

        if (img && !images.includes(img)) images.push(img)

      })

      this.parseImageField(question.image).forEach(img => {

        if (img && !images.includes(img)) images.push(img)

      })

      this.parseImageField(question.image_paths).forEach(img => {

        if (img && !images.includes(img)) images.push(img)

      })

      if (question.url) {

        const rawUrl = String(question.url).trim()

        if (rawUrl && !images.includes(rawUrl)) images.push(rawUrl)

      }

      return images.filter(img => img && String(img).trim())

    },

    resolveImageUrl(path) {

      if (!path) return ''

      const s = String(path).trim()

      if (!s) return ''

      if (/^(https?:)?\/\//i.test(s) || s.startsWith('data:')) return s

      if (s.startsWith('/api/')) return s

      if (/^\/[A-Za-z0-9_-]+\//.test(s)) {

        return `/api/file/preview?path=${encodeURIComponent(s)}`

      }

      return getMinioUrl(path)

    },



    // ===================== 纠错答题逻辑 =====================



    async startCorrection() {

      if (!this.current || !this.currentQuestion) return

      this.showCorrectionDialog = true

      this.correctionLoading = true

      this.correctionPhase = 'wrong'

      this.correctionAnswer = ''

      this.correctionAnswered = false

      this.correctionIsCorrect = false

      this.correctionSimilars = []

      this.correctionSimilarIdx = 0

      this.correctionSimilarResults = []

      this.correctionWrongResult = null

      this.correctionImageFile = null

      try {

        const q = this.currentQuestion

        console.log('纠错题目数据:', {

          options: q.options,

          optionsCn: q.optionsCn,

          optionsEn: q.optionsEn,

          optionsStr: q.optionsStr

        })



        // 优先使用已解析的 options 数组

        let opts = []

        if (Array.isArray(q.options) && q.options.length > 0) {

          if (typeof q.options[0] === 'string') {

            // 后端有时直接返回 ['(A) ...','(B) ...'] 这种格式，统一转为对象数组

            opts = q.options.map((s, idx) => ({ content: s, sort: idx + 1 }))

          } else {

            opts = q.options

          }

        } else {

          const optsStr = q.optionsCn || q.optionsEn || q.optionsStr || ''

          opts = this.parseCorrectionOptions(optsStr)

        }



        console.log('解析后的选项:', opts)

        this.correctionQuestion = q

        this.correctionOptions = opts

      } catch (e) {

        console.error('加载题目失败:', e)

        this.$message.error('加载题目失败')

        this.showCorrectionDialog = false

      } finally {

        this.correctionLoading = false

        this.correctionTypeset()

      }

    },



    onCorrectionFileChange(e) {

      const file = e.target && e.target.files && e.target.files[0]

      if (!file) return

      if (file.size > 10 * 1024 * 1024) {

        this.$message.error('图片大小不能超过10MB')

        return

      }

      this.correctionImageFile = file

      // 重置 input 以允许再次选择同一文件

      e.target.value = ''

    },



    async uploadCorrectionImage() {

      if (!this.correctionImageFile) return null

      try {

        this.correctionUploading = true

        const resp = await uploadToBucket(this.correctionImageFile, 'question-info')

        if (resp && resp.code === 1 && resp.data && resp.data.path) {

          return resp.data.path

        }

        return null

      } catch (e) {

        console.warn('纠错图片上传失败:', e)

        return null

      } finally {

        this.correctionUploading = false

      }

    },



    onCorrectionDialogClose(done) {

      if (this.correctionPhase === 'done') {

        done()

        return

      }

      this.$confirm('确定要退出纠错练习吗？进度不会保存。', '提示', {

        confirmButtonText: '退出',

        cancelButtonText: '继续练习',

        type: 'warning'

      }).then(() => done()).catch(() => {})

    },



    normalizeCorrectionAnswerValue(value) {

      const raw = String(value == null ? '' : value).trim()

      if (!raw) return ''

      const upper = raw.toUpperCase()

      const optionMatch = upper.match(/[A-D]/)

      if (optionMatch) return optionMatch[0]

      if (/(正确|对|TRUE|T|YES|Y)/i.test(raw) && !/(错误|错|FALSE|F|NO|N)/i.test(raw)) return 'T'

      if (/(错误|错|FALSE|F|NO|N)/i.test(raw)) return 'F'

      return upper.replace(/\s+/g, '')

    },



    async submitCorrectionAnswer() {

      if (!this.correctionAnswer) return

      this.correctionSubmitting = true

      try {

        const rawUa = String(this.correctionAnswer).trim()

        const rawCa = String(this.correctionQuestion && this.correctionQuestion.answer || '').trim()

        const ua = this.normalizeCorrectionAnswerValue(rawUa)

        const ca = this.normalizeCorrectionAnswerValue(rawCa)

        this.correctionIsCorrect = ua && ca ? ua === ca : rawUa.toUpperCase() === rawCa.toUpperCase()

        this.correctionAnswered = true



        const user = getTokenInfo && getTokenInfo()

        const userId = user && user.id

        const repoId = this.$route && this.$route.query && this.$route.query.repoId

        const repoIdVal = repoId ? (Number(repoId) || repoId) : null

        const quesId = this.current && this.current.quesId



        // 上传图片

        const imagePath = await this.uploadCorrectionImage()

        this.correctionImageFile = null

        this.correctionWrongResult = {
          quesId: quesId,
          userAnswer: this.correctionAnswer,
          answer: rawCa,
          isRight: this.correctionIsCorrect,
          content: this.correctionQuestion && (this.correctionQuestion.content || this.correctionQuestion.quesContent || this.correctionQuestion.quescontentCn || ''),
          analysis: this.correctionQuestion && (this.correctionQuestion.analysis || this.correctionQuestion.judge || this.correctionQuestion.judgeCn || ''),
          knowledge: this.correctionQuestion && (this.correctionQuestion.knowledge || ''),
          imagePath
        }



        // 原错题的订正过程不再通过 addRecord 回写，避免聚合接口把原错题记录的 isRight 从 0 覆盖成 1。

        // 原记录是否已完成订正统一由 finishCorrection() 中的 isReview=1 控制。



        if (this.correctionIsCorrect) {

          if (userId && repoIdVal && quesId) {

            await this.updateFinishedIds(userId, repoIdVal, quesId)

          }

          this.$message.success('回答正确！正在加载相似题...')

          await this.loadCorrectionSimilars()

        } else {

          this.$message.error(`回答错误，正确答案是：${rawCa || ca}，请重新作答`)

          this.correctionAnswered = false

          this.correctionAnswer = ''

        }

      } finally {

        this.correctionSubmitting = false

      }

      this.correctionTypeset()

    },



    async loadCorrectionSimilars() {

      try {

        const user = getTokenInfo && getTokenInfo()

        const userId = user && user.id

        const quesId = this.current && this.current.quesId

        const resp = await getSimilarQuestions(quesId, 3, userId)

        const arr = resp?.data || []

        this.correctionSimilars = Array.isArray(arr) ? arr : []

        if (!this.correctionSimilars.length) {

          await this.finishCorrection()

          return

        }

        this.correctionPhase = 'similar'

        this.correctionSimilarIdx = 0

        this.correctionAnswer = ''

        this.correctionAnswered = false

        this.correctionIsCorrect = false

        this.correctionImageFile = null

        this.correctionSimilarResults = []

      } catch (e) {

        this.$message.warning('无相似题，直接完成纠错')

        await this.finishCorrection()

      }

      this.correctionTypeset()

    },



    async submitSimilarAnswer() {

      if (!this.correctionAnswer) return

      this.correctionSubmitting = true

      try {

        const s = this.correctionSimilars[this.correctionSimilarIdx]

        const rawUa = String(this.correctionAnswer).trim()

        const rawCa = String(this.getSimilarAnswer(s) || '').trim()

        const ua = this.normalizeCorrectionAnswerValue(rawUa)

        const ca = this.normalizeCorrectionAnswerValue(rawCa)

        this.correctionIsCorrect = ua && ca ? ua === ca : rawUa.toUpperCase() === rawCa.toUpperCase()

        this.correctionAnswered = true



        // 记录本题作答结果，用于报告页展示

        const result = {

          quesId: s && s.id,

          userAnswer: this.correctionAnswer,

          answer: rawCa,

          isRight: this.correctionIsCorrect,

          content: this.getSimilarContent(s) || '',

          analysis: this.getSimilarAnalysis(s) || ''

        }

        this.$set(this.correctionSimilarResults, this.correctionSimilarIdx, result)



        const user = getTokenInfo && getTokenInfo()

        const userId = user && user.id

        const repoId = this.$route && this.$route.query && this.$route.query.repoId

        const repoIdVal = repoId ? (Number(repoId) || repoId) : null



        // 上传图片

        const imagePath = await this.uploadCorrectionImage()

        this.correctionImageFile = null



        if (userId && repoIdVal && s && s.id) {

          await addRecord({

            userId,

            quesId: s.id,

            repoId: repoIdVal,

            quesContent: this.getSimilarContent(s) || '',

            userAnswer: this.correctionAnswer,

            answer: ca,

            judge: this.getSimilarAnalysis(s) || '',

            knowledge: s.knowledge || '',

            isRight: this.correctionIsCorrect ? 1 : 0,

            isReview: 0,

            wrongCount: this.correctionIsCorrect ? 0 : 1,

            images: imagePath ? JSON.stringify([imagePath]) : null,

            time: new Date().toISOString()

          }).catch(() => {})



          // 更新 study_progress 和 study_scheme

          try {

            const todayStr = this.getTodayStr()

            const page = await getProgressPaging({ pageNum: 1, pageSize: 1, userId, repoId: repoIdVal, dateFrom: todayStr, dateTo: todayStr })

            const pdata = page?.data?.data ?? page?.data ?? {}

            const records = Array.isArray(pdata.records) ? pdata.records : []

            const first = records && records.length ? records[0] : null



            if (first) {

              const progressId = first.id ?? first.progressId

              if (progressId) {

                const progressFinished = first.finishedId ?? first.finished_id ?? ''

                const progressSet = new Set(progressFinished.split(/[，,\s]+/).filter(x => x).map(Number))



                if (this.correctionIsCorrect) {

                  // 答对：添加到 finished_id，增加 correct_count

                  progressSet.add(Number(s.id))

                  const progressMerged = Array.from(progressSet).filter(n => !isNaN(n) && n > 0).join(',')

                  const correctCount = Number(first.correctCount ?? first.correct_count ?? 0) + 1

                  const wrongCount = first.wrongCount ?? first.wrong_count ?? 0

                  const reviewDone = first.reviewDone ?? first.review_done ?? 0

                  await updateProgressFinished(progressId, progressMerged, correctCount, wrongCount, reviewDone)

                } else {

                  // 答错：增加 wrong_count

                  const progressMerged = Array.from(progressSet).filter(n => !isNaN(n) && n > 0).join(',')

                  const correctCount = first.correctCount ?? first.correct_count ?? 0

                  const wrongCount = Number(first.wrongCount ?? first.wrong_count ?? 0) + 1

                  const reviewDone = first.reviewDone ?? first.review_done ?? 0

                  await updateProgressFinished(progressId, progressMerged, correctCount, wrongCount, reviewDone)

                }

              }

            }



            // 更新 study_scheme finished_id（仅答对时）

            if (this.correctionIsCorrect) {

              const schemeResp = await getSchemeByUserIdAndRepoId(userId, repoIdVal)

              const scheme = schemeResp?.data?.data ?? schemeResp?.data ?? null

              if (scheme && scheme.id) {

                const schemeId = scheme.id

                const schemeFinished = scheme.finishedId ?? scheme.finished_id ?? ''

                const existSet = new Set(schemeFinished.split(/[，,\s]+/).filter(x => x).map(Number))

                existSet.add(Number(s.id))

                const merged = Array.from(existSet).filter(n => !isNaN(n) && n > 0).join(',')

                await updateSchemeFinishedIds(schemeId, merged)

              }

            }

          } catch (e) {

            console.warn('更新相似题进度失败:', e)

          }

        }



        if (this.correctionIsCorrect) {

          this.$message.success('回答正确！')

        } else {

          this.$message.error('回答错误，已加入错题本，请查看解析')

        }

      } finally {

        this.correctionSubmitting = false

      }

      this.correctionTypeset()

    },



    async nextSimilarOrFinish() {

      const next = this.correctionSimilarIdx + 1

      if (next < this.correctionSimilars.length) {

        this.correctionSimilarIdx = next

        this.correctionAnswer = ''

        this.correctionAnswered = false

        this.correctionIsCorrect = false

        this.correctionImageFile = null

        this.correctionTypeset()

      } else {

        // 先进入相似题报告页，确认后再完成纠错（标记订正）

        this.correctionPhase = 'report'

        this.correctionAnswer = ''

        this.correctionAnswered = false

        this.correctionIsCorrect = false

        this.correctionImageFile = null

        this.correctionTypeset()

      }

    },



    stripOptionPrefix(text) {

      if (!text) return ''

      return String(text)

        .replace(/^\(\s*[A-E]\s*\)\s*/i, '')

        .replace(/^[A-E]\s*\.?\s*/i, '')

        .trim()

    },



    async finishCorrection() {

      try {

        const user = getTokenInfo && getTokenInfo()

        const userId = user && user.id

        const repoId = this.$route && this.$route.query && this.$route.query.repoId

        const repoIdVal = repoId ? (Number(repoId) || repoId) : null

        if (this.current && this.current.id && this.current.userId && this.current.quesId) {

          const wrongResult = this.correctionWrongResult || {}

          const originalIsCorrect = wrongResult.isRight ? 1 : 0

          await updateRecord({

            id: this.current.id,

            userId: this.current.userId,

            quesId: this.current.quesId,

            userAnswer: wrongResult.userAnswer,

            answer: wrongResult.answer,

            judgeCn: wrongResult.analysis,

            knowledge: wrongResult.knowledge,

            isRight: originalIsCorrect,

            isReview: 1,

            wrongCount: originalIsCorrect ? 0 : 1,

            images: wrongResult.imagePath ? JSON.stringify([wrongResult.imagePath]) : undefined

          })

          if (userId && repoIdVal) {

            await this.applyCorrectionProgressAndScheme(userId, repoIdVal, this.current.quesId, originalIsCorrect === 1)

            await this.submitCorrectionStatus(userId, repoIdVal)

          }

          this.current.status = 'reviewed'

          const idx = this.rows.findIndex(r => r.id === this.current.id)

          if (idx !== -1) this.$set(this.rows, idx, { ...this.rows[idx], status: 'reviewed' })

          this.applyFilters()

        }

      } catch (e) {

        console.warn('标记订正状态失败:', e)

      }

      this.correctionPhase = 'done'

    },



    async applyCorrectionProgressAndScheme(userId, repoIdVal, quesId, isCorrect) {

      try {

        const todayStr = this.getTodayStr()

        const page = await getProgressPaging({ pageNum: 1, pageSize: 1, userId, repoId: repoIdVal, dateFrom: todayStr, dateTo: todayStr })

        const pdata = page?.data?.data ?? page?.data ?? {}

        const records = Array.isArray(pdata.records) ? pdata.records : []

        const first = records && records.length ? records[0] : null

        if (first) {

          const progressId = first.id ?? first.progressId

          if (progressId) {

            const progressFinished = first.finishedId ?? first.finished_id ?? ''

            const progressSet = new Set(String(progressFinished).split(/[，,\s]+/).filter(x => x).map(Number))

            if (isCorrect) {

              progressSet.add(Number(quesId))

            }

            const progressMerged = Array.from(progressSet).filter(n => !isNaN(n) && n > 0).join(',')

            const correctCount = Number(first.correctCount ?? first.correct_count ?? 0) + (isCorrect ? 1 : 0)

            const wrongCount = Number(first.wrongCount ?? first.wrong_count ?? 0) + (isCorrect ? 0 : 1)

            const reviewDone = first.reviewDone ?? first.review_done ?? 0

            await updateProgressFinished(progressId, progressMerged, correctCount, wrongCount, reviewDone)

          }

        }

        if (isCorrect) {

          const schemeResp = await getSchemeByUserIdAndRepoId(userId, repoIdVal)

          const scheme = schemeResp?.data?.data ?? schemeResp?.data ?? null

          if (scheme && scheme.id) {

            const schemeFinished = scheme.finishedId ?? scheme.finished_id ?? ''

            const existSet = new Set(String(schemeFinished).split(/[，,\s]+/).filter(x => x).map(Number))

            existSet.add(Number(quesId))

            const merged = Array.from(existSet).filter(n => !isNaN(n) && n > 0).join(',')

            await updateSchemeFinishedIds(scheme.id, merged)

          }

        }

      } catch (e) {

        console.warn('更新纠错进度失败:', e)

      }

    },



    async submitCorrectionStatus(userId, repoIdVal) {

      try {

        const quesIds = []

        if (this.current && this.current.quesId) {

          quesIds.push(Number(this.current.quesId))

        }

        const similarIds = Array.isArray(this.correctionSimilars)

          ? this.correctionSimilars.map(item => Number(item && item.id)).filter(id => !isNaN(id) && id > 0)

          : []

        similarIds.forEach(id => quesIds.push(id))

        const uniqueQuesIds = Array.from(new Set(quesIds)).filter(id => !isNaN(id) && id > 0)

        if (!uniqueQuesIds.length) {

          return

        }

        const rightCount = [this.correctionWrongResult, ...(this.correctionSimilarResults || [])]

          .filter(Boolean)

          .reduce((sum, item) => sum + (item.isRight ? 1 : 0), 0)

        await userStatusAdd({

          userId,

          repoId: repoIdVal,

          quesList: uniqueQuesIds.join(','),

          count: uniqueQuesIds.length,

          rightCount,

          source: '错题纠正'

        })

      } catch (e) {

        console.warn('写入错题纠正状态记录失败:', e)

      }

    },



    async updateFinishedIds(userId, repoIdVal, quesId) {

      try {

        // 更新 study-scheme finished_id

        const schemeResp = await getSchemeByUserIdAndRepoId(userId, repoIdVal)

        const scheme = schemeResp?.data

        const schemeId = scheme ? (scheme.id ?? scheme.schemeId) : null

        if (schemeId) {

          const schemeFinished = scheme?.finishedId || ''

          const existSet = new Set(schemeFinished.split(/[，,\s]+/).filter(x => x).map(Number))

          existSet.add(Number(quesId))

          const merged = Array.from(existSet).filter(n => !isNaN(n) && n > 0).join(',')

          await updateSchemeFinishedIds(schemeId, merged)

        }

        // 更新 study-progress finished_id 和 correct_count

        const todayStr = this.getTodayStr()

        const page = await getProgressPaging({ pageNum: 1, pageSize: 1, userId, repoId: repoIdVal, dateFrom: todayStr, dateTo: todayStr })

        const pdata = page?.data?.data ?? page?.data ?? {}

        const records = Array.isArray(pdata.records) ? pdata.records : []

        const first = records && records.length ? records[0] : null



        if (first) {

          const progressId = first.id ?? first.progressId

          if (progressId) {

            const progressFinished = first.finishedId ?? first.finished_id ?? ''

            const progressSet = new Set(progressFinished.split(/[，,\s]+/).filter(x => x).map(Number))



            const progressMerged = Array.from(progressSet).filter(n => !isNaN(n) && n > 0).join(',')

            const correctCount = Number(first.correctCount ?? first.correct_count ?? 0) + 1

            const wrongCount = first.wrongCount ?? first.wrong_count ?? 0

            const reviewDone = Number(first.reviewDone ?? first.review_done ?? 0) + 1

            await updateProgressFinished(progressId, progressMerged, correctCount, wrongCount, reviewDone)

          }

        }

      } catch (e) {

        console.warn('更新 finished_id 失败:', e)

      }

    },



    getTodayStr() {

      const d = new Date()

      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`

    },



    parseCorrectionOptions(optionsStr) {

      if (!optionsStr) return []

      if (Array.isArray(optionsStr)) {

        // 如果是对象数组，直接返回

        if (optionsStr.length > 0 && typeof optionsStr[0] === 'object') return optionsStr

        // 如果是字符串数组，转换为对象数组

        return optionsStr.map((opt, idx) => ({

          content: typeof opt === 'string' ? opt : (opt.content || opt.text || ''),

          sort: idx + 1

        }))

      }

      const s = String(optionsStr)

        .replace(/(^|[;\n\r\t\s])A\s*\.?\s*/g, '$1(A) ')

        .replace(/(^|[;\n\r\t\s])B\s*\.?\s*/g, '$1(B) ')

        .replace(/(^|[;\n\r\t\s])C\s*\.?\s*/g, '$1(C) ')

        .replace(/(^|[;\n\r\t\s])D\s*\.?\s*/g, '$1(D) ')

        .replace(/(^|[;\n\r\t\s])E\s*\.?\s*/g, '$1(E) ')

      const results = []

      const regex = /\(([A-E])\)\s*([^;\n\r]+)/g

      let m

      while ((m = regex.exec(s)) !== null) {

        const key = (m[1] || '').toUpperCase()

        const value = (m[2] || '').trim()

        const sort = key.charCodeAt(0) - 64

        results.push({ content: value, sort })

      }

      return results

    },



    parseDetailOptions(questionOrOptions) {

      const question = questionOrOptions && typeof questionOrOptions === 'object' && !Array.isArray(questionOrOptions)

        ? questionOrOptions

        : null

      const rawOptions = question

        ? (question.optionsCn || question.options || question.optionsStr || question.optionsEn || '')

        : questionOrOptions

      const parsedOptions = this.parseCorrectionOptions(rawOptions)

      const mergedMap = new Map()



      parsedOptions.forEach((opt, idx) => {

        const sort = opt && typeof opt.sort === 'number' ? opt.sort : idx + 1

        const content = this.stripOptionPrefix((opt && (opt.content || opt.text || opt.label || '')) || '')

        const existing = mergedMap.get(sort) || { sort, content: '', image: '' }

        const markdownImage = this.extractMarkdownImagePath(content)

        const plainText = content.replace(/!\[[^\]]*\]\([^)]+\)/g, '').trim()

        if (plainText && !existing.content) existing.content = plainText

        if (markdownImage && !existing.image) existing.image = markdownImage

        mergedMap.set(sort, existing)

      })



      this.parseImageField(question && question.optionImages).forEach((img, idx) => {

        const sort = idx + 1

        const existing = mergedMap.get(sort) || { sort, content: '', image: '' }

        if (!existing.image) existing.image = img

        mergedMap.set(sort, existing)

      })



      return Array.from(mergedMap.values()).sort((a, b) => a.sort - b.sort)

    },



    hasQuestionOptions(question) {

      return this.parseDetailOptions(question).length > 0

    },



    getOptionKey(opt, idx) {

      if (opt && typeof opt.sort === 'number') return String.fromCharCode(64 + opt.sort)

      return String.fromCharCode(65 + idx)

    },



    getOptionText(opt) {

      if (!opt) return ''

      if (typeof opt === 'string') {

        return this.stripOptionPrefix(opt)

      }

      return this.stripOptionPrefix((opt.content || opt.text || opt.label || '').toString())

    },



    getOptionImage(opt) {

      if (!opt) return ''

      return opt.image || this.extractMarkdownImagePath(this.getOptionText(opt)) || ''

    },



    extractMarkdownImagePath(text) {

      if (!text) return ''

      const match = String(text).match(/!\[[^\]]*\]\(([^)]+)\)/)

      return match && match[1] ? String(match[1]).trim() : ''

    },



    parseImageField(value) {

      if (!value) return []

      if (Array.isArray(value)) return value.map(item => String(item || '').trim()).filter(Boolean)

      const raw = String(value).trim()

      if (!raw) return []

      if (raw.startsWith('[') || raw.startsWith('{')) {

        try {

          const parsed = JSON.parse(raw)

          if (Array.isArray(parsed)) return parsed.map(item => String(item || '').trim()).filter(Boolean)

          if (typeof parsed === 'string') return parsed.trim() ? [parsed.trim()] : []

        } catch (e) {}

      }

      return raw.split(/[;,]/).map(item => item.trim()).filter(Boolean)

    },



    formatContent(text) {

      if (!text) return ''

      return this.renderText(text)

    },



    getSimilarContent(s) {

      if (!s) return ''

      return s.contentCn || s.content || s.question || s.contentEn || ''

    },



    getSimilarOptions(s) {

      if (!s) return []

      let raw = s.optionsCn || s.options || s.optionsStr || s.optionsEn || null

      if (!raw) return []

      if (Array.isArray(raw)) return raw

      if (typeof raw === 'string') return this.parseCorrectionOptions(raw)

      return []

    },



    getSimilarAnswer(s) {

      if (!s) return ''

      return s.answer || s.correctAnswer || ''

    },



    getQuestionAnswer(question) {

      if (!question) return ''

      if (this.langMode === 'en') return question.answerEn || question.answer || question.correctAnswer || ''

      if (this.langMode === 'bi') {

        const cn = question.answerCn || question.answer || question.correctAnswer || ''

        const en = question.answerEn || question.answer || question.correctAnswer || ''

        if (cn && en && cn !== en) return `${cn}<br/>${en}`

        return cn || en || ''

      }

      return question.answerCn || question.answer || question.correctAnswer || ''

    },



    getQuestionAnalysis(question) {

      if (!question) return ''

      if (this.langMode === 'en') return question.analysisEn || question.analysis || question.explain || ''

      if (this.langMode === 'bi') {

        const cn = question.analysisCn || question.analysis || question.explain || ''

        const en = question.analysisEn || question.analysis || question.explain || ''

        if (cn && en && cn !== en) return `${cn}<br/><br/>${en}`

        return cn || en || ''

      }

      return question.analysisCn || question.analysis || question.explain || ''

    },



    getSimilarAnalysis(s) {

      if (!s) return ''

      return s.analysisCn || s.analysis || s.explain || s.analysisEn || ''

    },



    getDifficultyType(difficulty) {

      if (!difficulty) return 'info'

      const num = Number(difficulty)

      if (!isNaN(num)) {

        if (num >= 1 && num <= 6) return 'success'

        if (num >= 7 && num <= 12) return ''

        if (num >= 13 && num <= 18) return 'warning'

        if (num >= 19 && num <= 25) return 'danger'

        return 'info'

      }

      const d = String(difficulty).toLowerCase()

      if (d.includes('入门') || d.includes('easy')) return 'success'

      if (d.includes('简单') || d.includes('simple')) return ''

      if (d.includes('一般') || d.includes('medium') || d.includes('中')) return 'warning'

      if (d.includes('困难') || d.includes('hard')) return 'danger'

      return 'info'

    },



    formatDifficulty(difficulty) {

      if (!difficulty) return '-'

      const num = Number(difficulty)

      if (!isNaN(num)) {

        if (num >= 1 && num <= 6) return '入门'

        if (num >= 7 && num <= 12) return '简单'

        if (num >= 13 && num <= 18) return '一般'

        if (num >= 19 && num <= 25) return '困难'

        return String(difficulty)

      }

      return difficulty

    },



    correctionTypeset() {

      this.$nextTick(() => {

        setTimeout(() => {

          try {

            if (window && window.MathJax && typeof window.MathJax.typesetPromise === 'function') {

              const dialogEl = document.querySelector('.correction-dialog')

              const scope = dialogEl || document.body

              if (typeof window.MathJax.typesetClear === 'function') {

                window.MathJax.typesetClear([scope])

              }

              window.MathJax.typesetPromise([scope]).then(() => {

                console.log('MathJax 纠错弹窗渲染完成')

              }).catch((err) => {

                console.warn('MathJax 纠错弹窗渲染失败:', err)

              })

            }

          } catch (e) {

            console.warn('MathJax 纠错弹窗渲染异常:', e)

          }

        }, 200)

      })

    },



    detailTypeset() {

      this.$nextTick(() => {

        setTimeout(() => {

          try {

            if (window && window.MathJax && typeof window.MathJax.typesetPromise === 'function') {

              const dialogEl = document.querySelector('.detail-dialog')

              const scope = dialogEl || document.body

              if (typeof window.MathJax.typesetClear === 'function') {

                window.MathJax.typesetClear([scope])

              }

              window.MathJax.typesetPromise([scope]).then(() => {

                console.log('MathJax 详情弹窗渲染完成')

              }).catch((err) => {

                console.warn('MathJax 详情弹窗渲染失败:', err)

              })

            }

          } catch (e) {

            console.warn('MathJax 详情弹窗渲染异常:', e)

          }

        }, 200)

      })

    },



    async saveNote() {

      if (!this.current) return

      this.noteSaving = true

      try {

        const recordId = this.current.id || this.current.recordId

        if (!recordId) {

          this.$message.error('无法保存笔记：记录ID不存在')

          return

        }

        await updateRecord({ id: recordId, mynote: this.editNote })

        this.current.note = this.editNote

        // 更新列表中的数据

        const idx = this.rows.findIndex(r => (r.id || r.recordId) === recordId)

        if (idx >= 0) this.rows[idx].note = this.editNote

        this.applyFilters()

      } catch (e) {

        console.error('保存笔记失败:', e)

        this.$message.error('保存笔记失败')

      } finally {

        this.noteSaving = false

      }

    },



    async onDetailFileChange(e) {

      const files = e.target.files

      if (!files || files.length === 0 || !this.current) return



      this.detailUploading = true

      try {

        // 批量上传所有选中的图片

        for (let i = 0; i < files.length; i++) {

          const file = files[i]

          const response = await uploadToBucket(file, 'question-info')



          if (response && response.data && response.data.path) {

            this.detailUploadedImages.push(response.data.path)

          }

        }



        // 清空文件选择器

        if (this.$refs.detailFileInput) this.$refs.detailFileInput.value = ''



        // 保存到数据库

        const recordId = this.current.id || this.current.recordId

        if (recordId) {

          await updateRecord({ id: recordId, images: JSON.stringify(this.detailUploadedImages) })

          if (this.current.rawData) this.current.rawData.images = JSON.stringify(this.detailUploadedImages)

          const rowIdx = this.rows.findIndex(r => (r.id || r.recordId) === recordId)

          if (rowIdx >= 0 && this.rows[rowIdx].rawData) {

            this.rows[rowIdx].rawData.images = JSON.stringify(this.detailUploadedImages)

          }

        }



        this.$message.success(`成功上传 ${files.length} 张做题过程图片`)

      } catch (e) {

        console.error('上传做题过程图片失败:', e)

        this.$message.error('上传做题过程图片失败')

      } finally {

        this.detailUploading = false

      }

    },



    async removeDetailImage(idx) {

      if (!this.current) return

      this.detailUploadedImages.splice(idx, 1)

      const recordId = this.current.id || this.current.recordId

      if (recordId) {

        try {

          await updateRecord({ id: recordId, images: JSON.stringify(this.detailUploadedImages) })

          if (this.current.rawData) this.current.rawData.images = JSON.stringify(this.detailUploadedImages)

          const rowIdx = this.rows.findIndex(r => (r.id || r.recordId) === recordId)

          if (rowIdx >= 0 && this.rows[rowIdx].rawData) {

            this.rows[rowIdx].rawData.images = JSON.stringify(this.detailUploadedImages)

          }

          this.$message.success('图片删除成功')

        } catch (e) {

          this.$message.error('删除图片失败')

        }

      }

    },



    // ---- 手写笔记图片 ----

    async onNoteFileChange(e) {

      const files = e.target.files

      if (!files || files.length === 0 || !this.current) return



      this.noteUploading = true

      try {

        // 批量上传所有选中的图片

        for (let i = 0; i < files.length; i++) {

          const file = files[i]

          const response = await uploadToBucket(file, 'question-info')



          if (response && response.data && response.data.path) {

            this.noteImages.push(response.data.path)

          }

        }



        // 清空文件选择器

        if (this.$refs.noteFileInput) this.$refs.noteFileInput.value = ''



        // 保存到数据库

        const recordId = this.current.id || this.current.recordId

        if (recordId) {

          await updateRecord({ id: recordId, noteImages: JSON.stringify(this.noteImages) })

          if (this.current.rawData) this.current.rawData.noteImages = JSON.stringify(this.noteImages)

          const rowIdx = this.rows.findIndex(r => (r.id || r.recordId) === recordId)

          if (rowIdx >= 0 && this.rows[rowIdx].rawData) {

            this.rows[rowIdx].rawData.noteImages = JSON.stringify(this.noteImages)

          }

        }



        this.$message.success(`成功上传 ${files.length} 张笔记图片`)

      } catch (e) {

        console.error('上传笔记图片失败:', e)

        this.$message.error('上传笔记图片失败')

      } finally {

        this.noteUploading = false

      }

    },



    async removeNoteImage(idx) {

      if (!this.current) return

      this.noteImages.splice(idx, 1)

      const recordId = this.current.id || this.current.recordId

      if (recordId) {

        try {

          await updateRecord({ id: recordId, noteImages: JSON.stringify(this.noteImages) })

          if (this.current.rawData) this.current.rawData.noteImages = JSON.stringify(this.noteImages)

          const rowIdx = this.rows.findIndex(r => (r.id || r.recordId) === recordId)

          if (rowIdx >= 0 && this.rows[rowIdx].rawData) {

            this.rows[rowIdx].rawData.noteImages = JSON.stringify(this.noteImages)

          }

          this.$message.success('图片删除成功')

        } catch (e) {

          this.$message.error('删除图片失败')

        }

      }

    }

  }

}

</script>



<style scoped>

.wrong-questions-container {

  padding: 20px 24px;

  min-height: 100vh;

  background: #f5f7fb;

}



.page-header {

  display: flex;

  align-items: center;

  justify-content: space-between;

  margin-bottom: 12px;

}



.page-title-area {

  display: flex;

  flex-direction: column;

}



.page-title {

  font-size: 20px;

  font-weight: 600;

  color: #303133;

}



.page-subtitle {

  margin-top: 4px;

  font-size: 13px;

  color: #909399;

}



.page-actions {

  display: flex;

  align-items: center;

}



.back-btn {

  display: inline-flex;

  align-items: center;

  color: #409eff;

}



.back-btn i {

  margin-right: 4px;

}



.summary-bar {

  display: flex;

  align-items: stretch;

  gap: 16px;

  margin-bottom: 12px;

}



.summary-item {

  min-width: 120px;

  padding: 10px 14px;

  border-radius: 8px;

  background: #fff;

  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);

}



.summary-label {

  font-size: 12px;

  color: #909399;

}



.summary-value {

  margin-top: 4px;

  font-size: 18px;

  font-weight: 600;

  color: #303133;

}



.summary-value.pending {

  color: #e6a23c;

}



.summary-value.reviewed {

  color: #67c23a;

}



.summary-tip {

  font-size: 13px;

  color: #606266;

}



.content-card {

  background: #fff;

  border-radius: 10px;

  padding: 14px 16px 10px;

  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);

}



.toolbar {

  display: flex;

  justify-content: space-between;

  align-items: center;

  gap: 12px;

  margin-bottom: 10px;

}



.toolbar-left {

  display: flex;

  align-items: center;

  gap: 8px;

}



.toolbar-right {

  display: flex;

  align-items: center;

}



.search-input {

  width: 260px;

}



.filter-select {

  width: 140px;

}



.filter-item {

  display: flex;

  align-items: center;

  gap: 6px;

}



.filter-label {

  color: #606266;

  font-size: 13px;

}



.record-rich-card {

  display: flex;

  flex-direction: column;

  gap: 6px;

  padding: 2px 0;

}



.record-rich-badges {

  display: flex;

  align-items: center;

  gap: 6px;

  flex-wrap: wrap;

}



.record-rich-badge {

  display: inline-flex;

  align-items: center;

  padding: 2px 8px;

  border-radius: 999px;

  font-size: 12px;

  line-height: 18px;

}



.record-rich-badge.is-warn {

  color: #e6a23c;

  background: #fdf6ec;

}



.record-rich-badge.is-pending {

  color: #f56c6c;

  background: #fef0f0;

}



.record-rich-badge.is-success {

  color: #67c23a;

  background: #f0f9eb;

}



.record-rich-title {

  color: #303133;

  line-height: 1.55;

  font-size: 15px;

  white-space: normal;

}



.record-rich-meta {

  display: flex;

  align-items: center;

  gap: 14px;

  flex-wrap: wrap;

}



.record-rich-meta-item {

  font-size: 12px;

  color: #909399;

}



.record-rich-meta-item.is-primary {

  color: #409eff;

  font-weight: 500;

}



.record-rich-meta-item.is-danger {

  color: #f56c6c;

}



.record-rich-meta-item.is-warn {

  color: #e6a23c;

}



.pagination {

  margin: 12px 0 6px;

  display: flex;

  justify-content: center;

}



.detail-panel {

  display: grid;

  grid-template-columns: 1.6fr 1fr;

  gap: 16px;

  margin-top: 8px;

}



.detail-left,

.detail-right {

  background: #fff;

  border-radius: 8px;

  padding: 12px;

  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);

}



.resource-block {

  display: flex;

  flex-direction: column;

  height: 100%;

}



.block-title {

  font-weight: 600;

  margin-bottom: 8px;

  padding-bottom: 6px;

  border-bottom: 2px solid #f0f0f0;

}



.question-content {

  white-space: pre-wrap;

  line-height: 1.8;

  margin-bottom: 8px;

}



.question-preview-card {

  display: flex;

  flex-direction: column;

  gap: 12px;

}



.question-preview-title {

  color: #303133;

  font-size: 18px;

  font-weight: 600;

  line-height: 1.75;

  white-space: normal;

}



.question-preview-meta-wrap {

  padding: 10px 12px;

  border-radius: 10px;

  background: #f8fafc;

  border: 1px solid #eef2f7;

}



.question-preview-meta-title {

  margin-bottom: 8px;

  font-size: 12px;

  font-weight: 600;

  color: #909399;

}



.question-preview-meta {

  display: flex;

  flex-wrap: wrap;

  gap: 8px;

}



.question-preview-course,

.question-preview-meta-item {

  display: inline-flex;

  align-items: center;

  padding: 4px 10px;

  border-radius: 999px;

  background: #fff;

  border: 1px solid #ebeef5;

  font-size: 12px;

  color: #606266;

  line-height: 18px;

}



.question-preview-course {

  color: #409eff;

  border-color: #d9ecff;

  background: #ecf5ff;

}



.question-preview-meta-item.is-danger {

  color: #f56c6c;

  border-color: #fde2e2;

  background: #fef0f0;

}



.question-preview-meta-item.is-wrong {

  color: #e6a23c;

  border-color: #faecd8;

  background: #fdf6ec;

}



.options {

  margin-bottom: 8px;

}



.option-item {

  padding: 8px 0;

  margin-bottom: 8px;

}



.analysis-content {

  min-height: 60px;

  background: #f8f9fa;

  border-radius: 6px;

  padding: 10px;

}



.ai-analysis-block {

  margin-bottom: 16px;

}



.ai-analysis-inner {

  background: #f0f7ff;

  border: 1px solid #d0e8ff;

  border-radius: 6px;

  padding: 10px 12px;

  display: flex;

  flex-direction: column;

  gap: 8px;

}



.ai-result-row {

  display: flex;

  align-items: flex-start;

  gap: 8px;

}



.ai-label {

  flex-shrink: 0;

  font-size: 13px;

  color: #606266;

  font-weight: 500;

  min-width: 70px;

  line-height: 1.6;

}



.ai-content {

  font-size: 13px;

  color: #303133;

  line-height: 1.6;

  white-space: pre-wrap;

}



.ai-suggestion {

  color: #e6a23c;

}



.note-actions {

  margin-top: 8px;

  display: flex;

  gap: 8px;

}



.resource-list {

  display: grid;

  gap: 8px;

}



.resource-item i {

  margin-right: 6px;

  color: #999;

}



.quick-actions {

  margin-top: auto;

  display: flex;

  gap: 8px;

  justify-content: flex-end;

}



.ml8 {

  margin-left: 8px;

}



.mt16 {

  margin-top: 16px;

}



/* 行样式：已复习更淡，未复习加粗，并增加 hover 效果 */

::v-deep .el-table .row-reviewed td {

  color: #9aa0a6;

  font-weight: 400;

}



::v-deep .el-table .row-pending td {

  color: #303133;

  font-weight: 600;

}



::v-deep .el-table__body tr:hover > td {

  background-color: #f5f7ff !important;

}



/* 图片上传模块样式 */

.image-upload-block {

  margin-top: 16px;

  padding-top: 16px;

  border-top: 1px solid #f0f0f0;

}



.upload-demo {

  margin-bottom: 12px;

}



.el-upload__tip {

  font-size: 12px;

  color: #909399;

  margin-top: 4px;

}



.uploaded-images {

  display: grid;

  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));

  gap: 12px;

  margin-top: 12px;

}



.image-item {

  position: relative;

  border-radius: 8px;

  overflow: hidden;

  border: 1px solid #e4e7ed;

  transition: all 0.3s;

}



.image-item:hover {

  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);

  border-color: #409eff;

}



.image-item img {

  width: 100%;

  height: 120px;

  object-fit: cover;

  display: block;

}



.image-actions {

  position: absolute;

  bottom: 0;

  left: 0;

  right: 0;

  background: rgba(0, 0, 0, 0.6);

  display: flex;

  justify-content: center;

  gap: 8px;

  padding: 4px;

  opacity: 0;

  transition: opacity 0.3s;

}



.image-item:hover .image-actions {

  opacity: 1;

}



.image-actions .el-button {

  color: #fff;

  padding: 4px 8px;

}



.image-actions .el-button:hover {

  color: #409eff;

}



.save-images-btn {

  margin-top: 16px;

  padding-top: 12px;

  border-top: 1px dashed #e4e7ed;

  display: flex;

  align-items: center;

  gap: 12px;

}



.save-tip {

  font-size: 13px;

  color: #909399;

}



/* 纠错答题弹窗样式 */

.correction-panel {

  padding: 4px 0;

}



.correction-phase-tip {

  display: flex;

  align-items: center;

  margin-bottom: 16px;

  padding: 10px 14px;

  background: #f4f6fb;

  border-radius: 8px;

  font-size: 13px;

  color: #606266;

}



.correction-q-meta {

  display: flex;

  align-items: center;

  flex-wrap: wrap;

  gap: 4px;

  margin-bottom: 10px;

}



.correction-content {

  line-height: 1.85;

  font-size: 14px;

  color: #303133;

  white-space: pre-wrap;

  margin-bottom: 14px;

  padding: 10px 12px;

  background: #fafafa;

  border-radius: 6px;

  border: 1px solid #ebeef5;

}



.correction-options {

  margin-bottom: 14px;

}



.correction-opt {

  display: flex;

  align-items: flex-start;

  margin-bottom: 8px;

  line-height: 1.7;

  white-space: normal;

}



::v-deep .correction-options .el-radio {

  display: flex;

  align-items: flex-start;

  white-space: normal;

  margin-bottom: 8px;

  line-height: 1.7;

}



::v-deep .correction-options .el-radio__label {

  white-space: normal;

  line-height: 1.7;

}



.correction-result {

  margin: 10px 0;

  font-size: 14px;

  font-weight: 500;

}



.correction-ok {

  color: #67c23a;

  display: flex;

  align-items: center;

  gap: 6px;

  padding: 8px 12px;

  background: #f0f9eb;

  border-radius: 6px;

}



.correction-bad {

  color: #f56c6c;

  display: flex;

  align-items: center;

  gap: 6px;

  padding: 8px 12px;

  background: #fef0f0;

  border-radius: 6px;

  flex-wrap: wrap;

}



.correction-analysis {

  margin: 12px 0;

  padding: 10px 14px;

  background: #fffbe6;

  border-left: 3px solid #e6a23c;

  border-radius: 4px;

  font-size: 13px;

  line-height: 1.7;

  color: #606266;

}



.correction-analysis-title {

  font-weight: 600;

  color: #e6a23c;

  margin-bottom: 6px;

}



.correction-actions {

  margin-top: 16px;

  display: flex;

  gap: 10px;

}



.correction-done {

  text-align: center;

  padding: 32px 0 16px;

}



/* 详情弹窗顶部徽章行 */

.question-preview-badges {

  display: flex;

  align-items: center;

  gap: 8px;

  flex-wrap: wrap;

}



/* 订正状态胶囊 */

.status-pill {

  display: inline-flex;

  align-items: center;

  gap: 4px;

  padding: 4px 14px;

  border-radius: 999px;

  font-size: 13px;

  font-weight: 600;

  letter-spacing: 0.5px;

}



.status-pill i {

  font-size: 14px;

}



.status-pill-pending {

  color: #e6a23c;

  background: linear-gradient(135deg, #fdf6ec 0%, #faecd8 100%);

  border: 1px solid #f5dab1;

  box-shadow: 0 1px 4px rgba(230, 162, 60, 0.15);

}



.status-pill-success {

  color: #67c23a;

  background: linear-gradient(135deg, #f0f9eb 0%, #e1f3d8 100%);

  border: 1px solid #c2e7b0;

  box-shadow: 0 1px 4px rgba(103, 194, 58, 0.15);

}



/* preview-badge 带图标 */

.preview-badge {

  display: inline-flex;

  align-items: center;

  gap: 3px;

  padding: 3px 10px;

  border-radius: 4px;

  font-size: 12px;

  font-weight: 500;

}



.preview-badge-danger {

  color: #f56c6c;

  background: #fef0f0;

  border: 1px solid #fde2e2;

}



.preview-badge-warn {

  color: #e6a23c;

  background: #fdf6ec;

  border: 1px solid #faecd8;

}



/* 右侧上传区域 */

.detail-right .question-block {

  margin-bottom: 16px;

  padding: 14px;

  background: #fafbfc;

  border: 1px dashed #e4e7ed;

  border-radius: 8px;

}



.upload-hint {

  font-size: 12px;

  color: #909399;

  margin-bottom: 8px;

  line-height: 1.5;

}



.upload-trigger-btn {

  border-style: dashed;

  width: 100%;

  margin-bottom: 4px;

}



.upload-preview-grid {

  display: grid;

  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));

  gap: 10px;

  margin-top: 10px;

}



.upload-preview-item {

  position: relative;

  border-radius: 8px;

  overflow: hidden;

  border: 1px solid #e4e7ed;

  transition: all 0.25s;

  background: #fff;

}



.upload-preview-item:hover {

  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);

  border-color: #409eff;

}



.upload-preview-item img {

  width: 100%;

  height: 140px;

  object-fit: cover;

  display: block;

}



.upload-preview-overlay {

  position: absolute;

  top: 0;

  left: 0;

  right: 0;

  bottom: 0;

  background: rgba(0, 0, 0, 0.35);

  display: flex;

  align-items: center;

  justify-content: center;

  opacity: 0;

  transition: opacity 0.25s;

}



.upload-preview-item:hover .upload-preview-overlay {

  opacity: 1;

}

</style>

